import React, { useState } from 'react';
import ImageUpload from './ImageUpload';
import StoryForm from './StoryForm';
import './CreateOptions.css';

const CreateOptions = () => {
  const [view, setView] = useState('options');
  const [selectedImages, setSelectedImages] = useState([]);

  const handleImageSelect = (images) => {
    setSelectedImages(images);
    setView('form');
  };

  // const resetToOptions = () => {
  //   setView('options');
  //   setSelectedImages([]);
  // };

  switch(view) {
    case 'image':
      return <ImageUpload 
        onComplete={handleImageSelect} 
      />;
    case 'form':
      return <StoryForm 
        selectedImages={selectedImages}
      />;
    default:
      return (
        <div className="create-options-container">
          <h2>Choose Story Creation Method</h2>
          <div className="options-buttons">
            <button 
              className="option-button"
              onClick={() => setView('image')}
            >
              Reference image for a Story e.g. textbook page
            </button>
            <button 
              className="option-button"
              onClick={() => setView('form')}
            >
              Turn an idea into a Story
            </button>
          </div>
        </div>
      );
  }
};

export default CreateOptions;